export const REMOVED = "removed";
export const CHURNED = "churned";
export const DISSOLVED = "dissolved";
export const MOVE_TO_SALES = "moveToSales";
export const RESTORE = "restore";
export const DELETE_ACTION = "deleteAction";
export const MOVE_TO_OPS = "MOVE_TO_OPS";
